<template>
  <div>
    <h1 class="settings-title">
      Integrations
    </h1>
    <div
      v-if="integrationsLoaded"
      class="mt-5">
      <b-card
        v-for="integration in integrations"
        :key="integration.keyword"
        class="integration-card">
        <b-row v-if="!integrationEnabled(integration.keyword)">
          <b-col cols="9">
            <img
              :src="`/static/img/integrations/${integration.logo}`"
              :alt="integration.name"
              width="140px">
            <div class="description-box mt-2 mb-0">
              Manage WhatsApp conversations directly from front.
            </div>
          </b-col>
          <b-col cols="3">
            <router-link
              :to="{ path: `integrations/${integration.keyword}` }"
              class="d-block mt-3 pt-1">
              <b class=" action-button text-primary float-right">
                <icon
                  width="12"
                  height="12"
                  name="plus"/> Enable
              </b>
            </router-link>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="9">
            <img
              :src="`/static/img/integrations/${integration.logo}`"
              :alt="integration.name"
              width="140px">
            <div class="description-box mt-2 mb-0">
              <icon
                width="14"
                height="14"
                name="check-circle"
                class="float-left mr-2"/>
              <span>Enabled</span>
            </div>
          </b-col>
          <b-col cols="3">
            <b
              class="action-button text-danger float-right mt-3 pt-1"
              @click="openDeleteIntegrationModal(integration.keyword)">
              <icon
                width="12"
                height="12"
                name="times"/> Remove
            </b>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div
      v-else
      class="settings-loader mt-5">
      <div
        class="loader loader-main">
        <div class="loading-circle"/>
      </div>
    </div>
    <IntegrationDeleteModal
      ref="integrationDeleteModal"
      @deleted="loadIntegrations"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import IntegrationDeleteModal from './modals/IntegrationDeleteModal';

export default {
  name: 'IntegrationList',
  components: {
    IntegrationDeleteModal,
  },
  data() {
    return {
      integrations: [
        {
          keyword: 'front',
          name: 'Front',
          logo: 'front.png',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      integrationsLoaded: 'integration/integrationsLoaded',
      enabledIntegrations: 'integration/integrations',
    }),
  },
  mounted() {
    this.loadIntegrations();
  },
  methods: {
    ...mapActions({
      fetchIntegrations: 'integration/fetchIntegrations',
      removeIntegrationFromList: 'integration/removeIntegrationFromList',
    }),
    loadIntegrations() {
      this.fetchIntegrations(this.$route.params.merchant_id);
    },
    integrationEnabled(keyword) {
      return !!this.$lodash.find(this.enabledIntegrations, integration => integration.app === keyword);
    },
    openDeleteIntegrationModal(keyword) {
      const integration = this.$lodash.find(this.enabledIntegrations, integration => integration.app === keyword);

      this.$refs.integrationDeleteModal.setIntegration(integration);
      this.$refs.integrationDeleteModal.show();
    },
  },
};
</script>
